<template>
  <div class="download-box-wrap">
    <div class="download-box" v-if="ShowGDownloadBox">
      <div class="download-box-container">
        <img class="download-box-imgStyle" :src="require('@/assets/images/account/grx_app_logo@2x.png')" />
        <span class="download-box-text">{{ $t('downloadBox.title') }}</span>
        <v-btn class="download-btn" color="var(--blue)" dark @click="directToAppStore">{{ $t('actions.download') }}</v-btn>
        <v-btn class="cross-btn" style="background-color: Transparent;" fab dark color="silver" @click="closeDownloadBox">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import tool from '@/common/js/tool.js';

export default {
  name: 'DownloadBox',
  data() {
    return {
      ShowGDownloadBox: false,
      downloadLink: ''
    };
  },
  methods: {
    directToAppStore() {
      //window.location = this.downloadLink;
      tool.scrollToElement(document.getElementById('appLinks'), -100, true);
    },
    closeDownloadBox() {
      this.ShowGDownloadBox = false;
      this.$emit('headerPositionBrowser',false);
    },
    checkIsMobile() {
      let isMobile = tool.browser().mobile;
      if (isMobile) {
        this.ShowGDownloadBox = true;
        this.$emit('headerPositionBrowser',true);
        return;
      } else {
        this.$emit('headerPositionBrowser',false);
        return;
      }
    },
    checkIosOrAndroid() {
      let browser = tool.browser();
      if (browser.ios) {
        this.downloadLink = 'https://apps.apple.com/us/app/grxtrade/id1495956494?ls=1';
      } else {
        this.downloadLink = 'https://play.google.com/store/apps/details?id=com.grxtrade.app';
      }
    }
  },
  mounted() {
    this.checkIsMobile();
    this.checkIosOrAndroid();
  }
};
</script>
<style lang="stylus" scoped>
.download-box-wrap {
  background-color: #fff;

  .download-box {
    padding: 10px 4px;
    background: black;
    border: 1px solid rgba(86, 61, 124, 0.2);
    width: 100%;
    max-height: 60px;
    position: initial;
    right: 0px;
    bottom: 0px;
    z-index: 1;
    opacity: 0.8;

    .download-box-container {
      display: flex;

      .download-box-text {
        color: white;
        font-weight: bold;
        margin: 6px 0px 0px 11px;
      }

      .download-box-imgStyle {
        max-width: 50px;
        max-height: 34px;
        margin-left: 7px;
        margin-top: 1px;
      }

      .download-btn {
        margin-bottom: 1px;
        margin-left: auto;
        margin-right: 5px;
        background-color: #1e49ac;
        color: #fff;
      }

      .cross-btn {
        width: 24px;
        height: 24px;
        top: 8px;
        margin-left: 5px;
      }
    }
  }
}
</style>
